import { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import {
  QUERY_WIDTHS,
  PROFILE_PAGE_URLS,
  SIMPLE_MOBILE_LAYOUT_URLS,
} from "@utils/index";
import { useCommonStore, useUserStore } from "@stores/index";
import {
  LeftSidebarNotAuth,
  RightSidebarNotAuth,
  Header,
  NavPanelMobile,
  NavPanelDesktop,
  LeftSidebarProfile,
  FooterMobile,
  FooterDesktop,
  Loader,
  UpdateBanner,
  FeatureTutorial,
} from "@components/index";

export const Layout = ({ children }: PropsWithChildren) => {
  const isStateInitiated = useCommonStore(
    ({ isStateInitiated }) => isStateInitiated,
  );
  const isLoading = useCommonStore(({ isLoading }) => isLoading);
  const isAuth = useCommonStore(({ isAuth }) => isAuth);
  const userId = useUserStore(({ userId }) => userId);
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });
  const location = useLocation();
  const isProfilePage = PROFILE_PAGE_URLS.includes(location.pathname);
  const isSimpleMobileLayout = !!SIMPLE_MOBILE_LAYOUT_URLS.find((url) =>
    location.pathname.includes(url),
  );

  if (!isStateInitiated) {
    return <Loader isFixed size="large" />;
  }

  return (
    <div className="bg-darkGray">
      {isAuth && userId && <FeatureTutorial />}
      <div className="min-h-dvh">
        {isAuth ? (
          <div className="relative rounded-t-lg bg-gradient-to-b from-[#283583] to-[#0B83CB] md:rounded-lg">
            {(!isMobile ||
              (isMobile && !isSimpleMobileLayout && !isProfilePage)) && (
              <Header />
            )}
            {!isMobile && <NavPanelDesktop />}
            {!isMobile && <UpdateBanner />}
            {isProfilePage ? (
              <div className="flex">
                {!isMobile && <LeftSidebarProfile />}
                <div className="min-h-dvh w-full bg-white-100 md:min-h-0 md:w-[calc(100dvw_-_280px)]">
                  {children}
                </div>
              </div>
            ) : (
              children
            )}
            {isMobile && !isSimpleMobileLayout && !isProfilePage && (
              <FooterMobile />
            )}
            {!isMobile && !isSimpleMobileLayout && !isProfilePage && (
              <FooterDesktop />
            )}
            {isMobile && !isSimpleMobileLayout && !isProfilePage && (
              <NavPanelMobile />
            )}
          </div>
        ) : (
          <div className="flex">
            {!isMobile && <LeftSidebarNotAuth />}
            <RightSidebarNotAuth>{children}</RightSidebarNotAuth>
          </div>
        )}
        <ToastContainer
          position={isMobile ? "top-center" : "bottom-right"}
          autoClose={10000}
          hideProgressBar
          closeOnClick
          pauseOnFocusLoss={false}
          pauseOnHover={false}
          transition={Slide}
          theme="colored"
          className="toastElement"
        />
        {isLoading && <Loader isFixed size="large" />}
      </div>
    </div>
  );
};
